<script setup>
import NavBar from './components/NavBar.vue'
import FooterBar from './components/FooterBar.vue'
import CustomerServiceSidebar from './components/CustomerServiceSidebar.vue'
</script>

<template>
  <div class="app-layout">
    <NavBar />
    <main>
      <router-view />
    </main>
    <CustomerServiceSidebar />
    <FooterBar />
  </div>
</template>

<style>
@import './assets/design-tokens.css';

/* Global Resets & Styles */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #333;
  line-height: 1.5;
  background-color: #fcfcfc;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
}

.app-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}
</style>
